import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { getCamerasBySiteAlerts } from "../Alerts/AlertsUtils/getCamerasBySiteAlerts";
import { NavigateFunction } from "react-router-dom";

export const SiteDropDownAILink = ({
  siteOptions,
  loadingSites,
  siteDropDownValue,
  setSiteDropDownValue,
  setCameraDropDownValue,
  userFilters,
  setUserFilters,
  setCameraOptions,
  setLoadingCameras,
  showUserDropDown,
  navBarCollapsed,
  navigate,
}: {
  siteOptions: any;
  loadingSites: boolean;
  siteDropDownValue: string | null;
  setSiteDropDownValue: Dispatcher<string | null>;
  setCameraDropDownValue: Dispatcher<string | null>;
  userFilters: any;
  setUserFilters: any;
  setCameraOptions: any;
  setLoadingCameras: Dispatcher<boolean>;
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
  navigate: NavigateFunction;
}) => {
  const siteIds = new Map();
  siteOptions.forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique names
  siteOptions.forEach((object: any) => {
    if (!uniqueNames.has(object.name)) {
      uniqueNames.add(object.name);
      options.push(object.name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 140 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 120 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 180 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 160 };
  }

  return (
    <div key="site_dropdown">
      <Autocomplete
        value={siteDropDownValue}
        disablePortal
        options={options}
        loading={loadingSites}
        onChange={(event, value: any) => {
          if (value !== null) {
            setSiteDropDownValue(value);
            setCameraDropDownValue(null);
            getCamerasBySiteAlerts(
              [siteIds.get(value)],
              navigate,
              setCameraOptions,
              setLoadingCameras
            );
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site_ids: [siteIds.get(value)],
                camera_ids: [],
              };
            });
          } else {
            // setFetchingFilteredData(true);
            setSiteDropDownValue(value);
            setCameraDropDownValue(null);
            setCameraOptions([]);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site_ids: [],
                camera_ids: [],
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSites ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
